module.exports = __webpack_public_path__ + "static/media/deffenbaughIndustries.ab491951.png";